export default __webpack_public_path__ + "static/media/stephanie.2cd4eee2.jpeg";